import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import Header from '../Header';
import Footer from '../Footer';
import Alert from '../Alert';
import ModalConfirm from '../ModalConfirm';
// Styles
import styles from './Layout.styl';

const cx = classNames.bind(styles);

export default function Layout(props) {
  const { children, simple, theme } = props;

  const isPhone = useSelector(state => state.responsive.isPhone);

  return (
    <div className={cx('Layout', `Layout_theme_${theme}`, { Layout_simple: simple })}>
      {!(isPhone && simple) && <Header className={cx('Layout__header')} />}
      <div className={cx('Layout__main')}>{children}</div>
      {!(isPhone && simple) && <Footer className={cx('Layout__footer')} />}
      <ModalConfirm />
      <Alert />
    </div>
  );
}

Layout.defaultProps = {
  simple: true,
  theme: 'primary',
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  simple: PropTypes.bool,
  theme: PropTypes.oneOf(['primary', 'secondary']),
};
